export const screenSize = {
    xs: 0, //mobile
    sm: 600, //tablet
    md: 900, //small screen
    lg: 1200, //medium screen
    xl: 1536, //big screen
};
const base = 16;
export const px2rem = (px: number) => `${(px / base).toFixed(4)}rem`;
